// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WEzN4V {
    /* Reset start */
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;

    background: transparent;

    color: inherit;
    font: inherit;

    line-height: normal;

    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;

    -webkit-appearance: none;
    /* Reset end */

    cursor: pointer;
    outline:none;
}

/* Reset start */
.WEzN4V::-moz-focus-inner {
    border: 0;
    padding: 0;
}
/* Reset end */

`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `WEzN4V`
};
export default ___CSS_LOADER_EXPORT___;
